<app-table
  [cols]="cols"
  [elements]="types"
  modelName="tipos"
  sortField="paymentResponseMessageTypeId"
  [addButton]="false"
  [lazy]="false"
  *ngIf="types"
  tableTitle="Tipos de erro de cobranças"
/>
